const pontoMilhar = (val) => {
  let int = val;
  const partes = [];
  while (int !== "") {
    partes.unshift(int.substr(-3));
    int = int.substr(0, int.length - 3);
  }
  return partes.join(".");
};

const build = {
  cpf(val) {
    const numeros = unmaskCPF(val);
    const secoes = [
      numeros.substr(0, 3),
      numeros.substr(3, 3),
      numeros.substr(6, 3),
    ];
    let cpf = secoes.filter((s) => s !== "").join(".");
    const dig = numeros.substr(9, 3);
    if (dig !== "") {
      cpf += `-${dig}`;
    }
    return cpf;
  },
  cnpj(val) {
    const numeros = unmaskCNPJ(val);
    const secoes = [
      numeros.substr(0, 2),
      numeros.substr(2, 3),
      numeros.substr(5, 3),
    ];
    let cnpj = secoes.filter((s) => s !== "").join(".");
    const contra = numeros.substr(8, 4);
    if (contra !== "") {
      cnpj += `/${contra}`;
    }
    const dig = numeros.substr(12, 2);
    if (dig !== "") {
      cnpj += `-${dig}`;
    }
    return cnpj;
  },
  phone(val) {
    let tel = "";
    const num = unmaskPhone(val);

    const ddd = num.substr(0, 3);

    if (ddd != "") {
      tel = `(${ddd})`;
    }

    const l1 = num.length === 12 ? 5 : 4;
    const secoes = [num.substr(3, l1), num.substr(3 + l1, 4)];
    tel += secoes.filter((s) => s !== "").join("-");

    return tel;
  },
  cep(val) {
    const num = unmaskCEP(val);
    const secoes = [num.substr(0, 5), num.substr(5, 3)];
    return secoes.filter((s) => s !== "").join("-");
  },
  decimal3(val) {
    const num = parseInt(unmaskDecimal(val, 3).replace(".", ""));
    const secoes = (num / 1000).toFixed(3).split(".");
    secoes[0] = pontoMilhar(secoes[0]);

    return secoes.join(",");
  },
  decimal2(val) {
    const num = parseInt(unmaskDecimal(val, 2).replace(".", ""));
    const secoes = (num / 100).toFixed(2).split(".");
    secoes[0] = pontoMilhar(secoes[0]);

    return secoes.join(",");
  },
  money(val) {
    return "R$ " + this.decimal2(val);
  },
};

const unmaskCPF = (cpf) => cpf.replace(/[^\d]/g, "");
const unmaskCNPJ = (cnpj) => cnpj.replace(/[^\d]/g, "");
const unmaskPhone = (phone) => phone.replace(/[^\d]/g, "");
const unmaskCEP = (cep) => cep.replace(/[^\d]/g, "");
const unmaskDecimal = (num, casas) => {
  const clean = (num || "").toString().replace(/[^\d.,]/g, "");
  if (clean) {
    return isNaN(clean)
      ? clean.replace(/\./g, "").replace(",", ".")
      : parseFloat(clean).toFixed(casas);
  } else {
    return "0,000";
  }
};
export { build, unmaskCPF, unmaskCNPJ, unmaskPhone, unmaskCEP, unmaskDecimal };
